export const NAME = "core-user-info";

export const FETCHING_AGENTS = `${NAME}/FETCHING_AGENTS`;

export const MESSAGES_UNAVAILABLE = `${NAME}/MESSAGES_UNAVAILABLE`;
